import axios from 'axios'
//constantes
const dataInicial = {
    login: {
        login: false,
    },
    statususer: {},
    users: [],
}

//types
const OBTENER_LOGGIN_EXITO = 'OBTENER_LOGGIN_EXITO'
const OBTENER_ESTATUS_USER = 'OBTENER_ESTATUS_USER'
const GET_USERS_EXITO = 'GET_USERS_EXITO'
const { REACT_APP_API_URL } = process.env;
//reducer
export default function UserReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_LOGGIN_EXITO:
            return { ...state, login: action.payload }
        case OBTENER_ESTATUS_USER:
            return { ...state, statususer: action.payload }
        case GET_USERS_EXITO:
            return { ...state, users: action.payload }
        default:
            return state
    }
}
//acciones


export const loggin = (resultado) => async (dispatch, getState) => {
    try {
        const res = resultado
        dispatch({
            type: OBTENER_LOGGIN_EXITO,
            payload: res
        })
        sessionStorage.setItem('%t', (res.token))
        sessionStorage.setItem('_sr3', (res.usuario.niveldeacceso))
        sessionStorage.setItem('p', (res.sm))
        sessionStorage.setItem('_s', (res.variant))
        sessionStorage.setItem('_user', (res.msg))
        sessionStorage.setItem('D', JSON.stringify(res.usuario))

    } catch (error) {
        console.log(error)
    }
}


export const estatususer = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: OBTENER_ESTATUS_USER,
            payload: sessionStorage.getItem('D', JSON.parse)
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerusers = () => async (dispatch, getState) => {

    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/usuarios`, requestOptions)
        dispatch({
            type: GET_USERS_EXITO,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}